import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { Suspense, lazy } from 'preact/compat';
import { useTranslation } from 'react-i18next';
import i18n from '@/lib/i18n';
export default function Footer() {
    const { t } = useTranslation();
    const locale = i18n.language;
    const logoPath = locale === 'cy' ? 'wales-recycles-logo' : 'recycle-logo';
    const LogoSvg = lazy(() => import(`./${logoPath}.svg?react`));
    const links = ['privacy', 'cookies', 'accessibility'].map((item) => ({
        href: t(`components.footer.nav.${item}Link`),
        label: t(`components.footer.nav.${item}Label`),
    }));
    return (_jsxs("locator-footer", { children: [_jsxs("h2", { className: "locator-footer-title", children: [t('components.footer.poweredBy'), ' ', _jsx(Suspense, { fallback: null, children: _jsx(LogoSvg, { title: t('components.footer.recycleNow') }) })] }), _jsxs("p", { children: [t('components.footer.inPartnership'), " Valpak"] }), _jsx("nav", { children: _jsx("ul", { children: links.map((link) => (_jsx("li", { children: _jsx("a", { href: link.href, rel: "noopener noreferrer", target: "_blank", children: link.label }) }, link.label))) }) })] }));
}
